module.exports = __webpack_public_path__ + "static/media/home-page-lander.35ab816b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-page-lander.jpg
// module id = ./src/assets/home-page-lander.jpg
// module chunks = 2